import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneChallengesEncounteredThatAffected = createAsyncThunk(
  "GetOneChallengesEncounteredThatAffected/GetOneChallengesEncounteredThatAffected",
  async (pR_challengesEncounteredThatAffectedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_challengesEncounteredThatAffected/GetPR_challengesEncounteredThatAffectedData",
        {
          pR_challengesEncounteredThatAffectedId:
            pR_challengesEncounteredThatAffectedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "jojo");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteChallengesEncounteredThatAffected = createAsyncThunk(
  "DeleteChallengesEncounteredThatAffected/DeleteChallengesEncounteredThatAffected",
  async (pR_challengesEncounteredThatAffectedId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_challengesEncounteredThatAffected/DeletePR_challengesEncounteredThatAffectedData",
        {
          pR_challengesEncounteredThatAffectedId:
            pR_challengesEncounteredThatAffectedId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListChallengesEncounteredThatAffected = createAsyncThunk(
  "GetListChallengesEncounteredThatAffected/GetListChallengesEncounteredThatAffected",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_challengesEncounteredThatAffected/GetPR_challengesEncounteredThatAffectedListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateGetListChallengesEncounteredThatAffectedData =
  createAsyncThunk(
    "UpdateGetListChallengesEncounteredThatAffectedData/UpdateGetListChallengesEncounteredThatAffectedData",
    async (ChallengesEncounteredThatAffectedData, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/PR_challengesEncounteredThatAffected/UpdatePR_challengesEncounteredThatAffectedData",
          {
            pR_challengesEncounteredThatAffectedId:
              ChallengesEncounteredThatAffectedData.pR_challengesEncounteredThatAffectedId,
            challengeDetails:
              ChallengesEncounteredThatAffectedData.challengeDetails,
            challengeCause:
              ChallengesEncounteredThatAffectedData.challengeCause,
            suggestedSolutions:
              ChallengesEncounteredThatAffectedData.suggestedSolutions,
            pR_ReportsStagesGuid:
              ChallengesEncounteredThatAffectedData.pR_ReportsStagesGuid,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataproject");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
export const AddChallengesEncounteredThatAffectedData = createAsyncThunk(
  "AddChallengesEncounteredThatAffectedData/AddChallengesEncounteredThatAffectedData",
  async (ChallengesEncounteredThatAffected, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_challengesEncounteredThatAffected/AddPR_challengesEncounteredThatAffectedData",
        {
          challengeDetails: ChallengesEncounteredThatAffected.challengeDetails,
          challengeCause: ChallengesEncounteredThatAffected.challengeCause,
          suggestedSolutions:
            ChallengesEncounteredThatAffected.suggestedSolutions,
          pR_ReportsStagesGuid:
            ChallengesEncounteredThatAffected.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateChallengesEncounteredThatAffected = createAsyncThunk(
  "ValidateChallengesEncounteredThatAffected/ValidateChallengesEncounteredThatAffected",
  async (ChallengesEncounteredThatAffected, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_challengesEncounteredThatAffected/ValidatePR_challengesEncounteredThatAffectedData",
        {
          challengeDetails: ChallengesEncounteredThatAffected.challengeDetails,
          challengeCause: ChallengesEncounteredThatAffected.challengeCause,
          suggestedSolutions:
            ChallengesEncounteredThatAffected.suggestedSolutions,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteForChallengesEncounteredThatAffected =
  createAsyncThunk(
    "GetSpecificRowNoteForChallengesEncounteredThatAffected/GetSpecificRowNoteForChallengesEncounteredThatAffected",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
          parameters
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field

        return data.filter((item) => item.incrementNumber - 1 === 1);
        //   return data;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const ChallengesEncounteredThatAffected = createSlice({
  name: "ChallengesEncounteredThatAffected",
  initialState: {
    OneChallengesEncounteredThatAffected: {},
    loadingOneChallengesEncounteredThatAffected: false,
    errorOneChallengesEncounteredThatAffected: null,

    AddChallengesEncounteredThatAffected: {},
    loadingAddChallengesEncounteredThatAffected: false,
    errorAddChallengesEncounteredThatAffected: null,

    UpdateChallengesEncounteredThatAffected: {},
    loadingUpdateChallengesEncounteredThatAffected: false,
    errorUpdateChallengesEncounteredThatAffected: null,

    DeleteChallengesEncounteredThatAffected: {},
    loadingDeleteChallengesEncounteredThatAffected: false,
    errorDeleteChallengesEncounteredThatAffected: null,

    ListChallengesEncounteredThatAffected: {},
    loadingListChallengesEncounteredThatAffected: false,
    errorListChallengesEncounteredThatAffected: null,

    ChallengesEncounteredThatAffectedValidate: [],
    loadingChallengesEncounteredThatAffectedValidate: false,
    errorChallengesEncounteredThatAffectedValidate: null,

    OneSpecificRowNoteForChallengesEncounteredThatAffected: {},
    loadingOneSpecificRowNoteForChallengesEncounteredThatAffected: false,
    errorOneSpecificRowNoteForChallengesEncounteredThatAffected: null,
  },
  reducers: {
    restValidateChallengesEncounteredThatAffected: (state, action) => {
      state.ChallengesEncounteredThatAffectedValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneChallengesEncounteredThatAffected.pending,
        (state, action) => {
          state.loadingOneChallengesEncounteredThatAffected = true;
          state.OneChallengesEncounteredThatAffected = action.payload;
          state.errorOneOpportunitiesObtained = null;
        }
      )
      .addCase(
        GetOneChallengesEncounteredThatAffected.fulfilled,
        (state, action) => {
          state.loadingOneChallengesEncounteredThatAffected = false;
          state.OneChallengesEncounteredThatAffected = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneChallengesEncounteredThatAffected.rejected,
        (state, action) => {
          state.loadingOneChallengesEncounteredThatAffected = false;
          state.errorOneChallengesEncounteredThatAffected = action.payload;
        }
      )

      .addCase(
        DeleteChallengesEncounteredThatAffected.pending,
        (state, action) => {
          state.loadingDeleteChallengesEncounteredThatAffected = true;
          state.DeleteChallengesEncounteredThatAffected = action.payload;
          state.errorDeleteChallengesEncounteredThatAffected = null;
        }
      )
      .addCase(
        DeleteChallengesEncounteredThatAffected.fulfilled,
        (state, action) => {
          state.loadingDeleteChallengesEncounteredThatAffected = false;
          state.DeleteChallengesEncounteredThatAffected = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteChallengesEncounteredThatAffected.rejected,
        (state, action) => {
          state.loadingDeleteChallengesEncounteredThatAffected = false;
          state.errorDeleteChallengesEncounteredThatAffected = action.payload;
        }
      )
      .addCase(
        GetListChallengesEncounteredThatAffected.pending,
        (state, action) => {
          state.loadingListChallengesEncounteredThatAffected = true;
          state.ListChallengesEncounteredThatAffected = action.payload;
          state.errorListChallengesEncounteredThatAffected = null;
        }
      )
      .addCase(
        GetListChallengesEncounteredThatAffected.fulfilled,
        (state, action) => {
          state.loadingListChallengesEncounteredThatAffected = false;
          state.ListChallengesEncounteredThatAffected = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetListChallengesEncounteredThatAffected.rejected,
        (state, action) => {
          state.loadingListChallengesEncounteredThatAffected = false;
          state.errorListChallengesEncounteredThatAffected = action.payload;
        }
      )
      .addCase(
        UpdateGetListChallengesEncounteredThatAffectedData.pending,
        (state, action) => {
          state.loadingUpdateChallengesEncounteredThatAffected = true;
          state.UpdateChallengesEncounteredThatAffected = action.payload;
          state.errorUpdateChallengesEncounteredThatAffected = null;
        }
      )
      .addCase(
        UpdateGetListChallengesEncounteredThatAffectedData.fulfilled,
        (state, action) => {
          state.loadingUpdateChallengesEncounteredThatAffected = false;
          state.UpdateChallengesEncounteredThatAffected = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        UpdateGetListChallengesEncounteredThatAffectedData.rejected,
        (state, action) => {
          state.loadingUpdateChallengesEncounteredThatAffected = false;
          state.errorUpdateChallengesEncounteredThatAffected = action.payload;
        }
      )
      .addCase(
        ValidateChallengesEncounteredThatAffected.pending,
        (state, action) => {
          state.loadingChallengesEncounteredThatAffectedValidate = true;
          state.ChallengesEncounteredThatAffectedValidate = action.payload;
          state.errorChallengesEncounteredThatAffectedValidate = null;
        }
      )
      .addCase(
        ValidateChallengesEncounteredThatAffected.fulfilled,
        (state, action) => {
          state.loadingChallengesEncounteredThatAffectedValidate = false;
          state.ChallengesEncounteredThatAffectedValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateChallengesEncounteredThatAffected.rejected,
        (state, action) => {
          state.loadingChallengesEncounteredThatAffectedValidate = false;
          state.errorChallengesEncounteredThatAffectedValidate = action.payload;
        }
      )
      .addCase(
        AddChallengesEncounteredThatAffectedData.pending,
        (state, action) => {
          state.loadingAddChallengesEncounteredThatAffected = true;
          state.AddChallengesEncounteredThatAffected = action.payload;
          state.errorAddChallengesEncounteredThatAffected = null;
        }
      )
      .addCase(
        AddChallengesEncounteredThatAffectedData.fulfilled,
        (state, action) => {
          state.loadingAddChallengesEncounteredThatAffected = false;
          state.AddChallengesEncounteredThatAffected = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        AddChallengesEncounteredThatAffectedData.rejected,
        (state, action) => {
          state.loadingAddChallengesEncounteredThatAffected = false;
          state.errorAddChallengesEncounteredThatAffected = action.payload;
        }
      )
      .addCase(
        GetSpecificRowNoteForChallengesEncounteredThatAffected.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteForChallengesEncounteredThatAffected = true;
          state.OneSpecificRowNoteForChallengesEncounteredThatAffected =
            action.payload;
          state.errorOneSpecificRowNoteForChallengesEncounteredThatAffected =
            null;
        }
      )
      .addCase(
        GetSpecificRowNoteForChallengesEncounteredThatAffected.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteForChallengesEncounteredThatAffected = false;
          state.OneSpecificRowNoteForChallengesEncounteredThatAffected =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteForChallengesEncounteredThatAffected.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteForChallengesEncounteredThatAffected = false;
          state.errorOneSpecificRowNoteForChallengesEncounteredThatAffected =
            action.payload;
        }
      );
  },
});
export const { restValidateChallengesEncounteredThatAffected } =
  ChallengesEncounteredThatAffected.actions;
export default ChallengesEncounteredThatAffected.reducer;
